import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import './Testimonials.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { googleReviewsService } from '../../services/googleReviewsService';
import { getStarRating } from '../../config/googlePlaces';

const Testimonials = () => {
  const [reviewsData, setReviewsData] = useState({
    reviews: [],
    overallRating: 0,
    totalReviews: 0,
    lastUpdated: null
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch reviews on component mount
  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const data = await googleReviewsService.fetchReviews();
      setReviewsData(data);
    } catch (err) {
      console.error('Error fetching reviews:', err);
      setError('Unable to load reviews at this time');
    } finally {
      setLoading(false);
    }
  };

  // Refresh reviews manually
  const refreshReviews = () => {
    googleReviewsService.clearCache();
    fetchReviews();
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <button className="next-button">&#8250;</button>,
    prevArrow: <button className="prev-button">&#8249;</button>,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  // Render star rating
  const renderStars = (rating) => {
    const { fullStars, hasHalfStar, emptyStars } = getStarRating(rating);
    
    return (
      <div className="testimonial-rating">
        {Array.from({ length: fullStars }, (_, i) => (
          <span key={`full-${i}`} className="star filled">★</span>
        ))}
        {hasHalfStar && <span className="star half">☆</span>}
        {Array.from({ length: emptyStars }, (_, i) => (
          <span key={`empty-${i}`} className="star">☆</span>
        ))}
      </div>
    );
  };

  // Loading state
  if (loading) {
    return (
      <div className="testimonials-container">
        <div className='container'>
          <h2 className="testimonials-title">Testimonials</h2>
          <div className="loading-state">
            <div className="loading-spinner"></div>
            <p>Loading reviews...</p>
          </div>
        </div>
      </div>
    );
  }

  // Error state
  // if (error) {
  //   return (
  //     <div className="testimonials-container">
  //       <div className='container'>
  //         <h2 className="testimonials-title">Testimonials</h2>
  //         <div className="error-state">
  //           <p>{error}</p>
  //           <button onClick={refreshReviews} className="retry-button">
  //             Try Again
  //           </button>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="testimonials-container">
      <div className='container'>
        <h2 className="testimonials-title">Testimonials</h2>
        
        {/* Rating Summary */}
        <div className="rating-summary">
          <div className="average-rating">
            <span className="rating-number">{reviewsData.overallRating.toFixed(1)}</span>
            <div className="rating-stars">
              {renderStars(reviewsData.overallRating)}
            </div>
            <span className="total-reviews">Based on {reviewsData.totalReviews} reviews</span>
            {/* {reviewsData.lastUpdated && (
              <span className="last-updated">
                Last updated: {new Date(reviewsData.lastUpdated).toLocaleDateString()}
              </span>
            )} */}
          </div>
          {/* <button onClick={refreshReviews} className="refresh-button" title="Refresh reviews">
            🔄
          </button> */}
        </div>

        {/* Reviews Slider */}
        {reviewsData.reviews.length > 0 ? (
          <Slider {...settings}>
            {reviewsData.reviews.map((review) => (
              <div className="testimonial-card" key={review.id}>
                <div className="testimonial-image">
                  {review.profilePhoto ? (
                    <img 
                      src={review.profilePhoto} 
                      alt={review.name}
                      className="profile-photo"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                      }}
                    />
                  ) : null}
                  <div className={`initials-circle ${review.profilePhoto ? 'fallback' : ''}`}>
                    {review.initials}
                  </div>
                </div>
                <div className="testimonial-content">
                  <h3>{review.name}</h3>
                  <p className="testimonial-title">{review.title}</p>
                  <p className="testimonial-text">{review.text}</p>
                  {renderStars(review.rating)}
                  <div className="review-meta">
                    <span className="review-date">{review.relativeTime || review.date}</span>
                    {review.language !== 'en' && (
                      <span className="review-language">({review.language})</span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          <div className="no-reviews">
            <p>No reviews available at the moment.</p>
            {/* <button onClick={refreshReviews} className="retry-button">
              Refresh
            </button> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default Testimonials;
